import {apiUrl, alert} from '../helper'
import echarts from 'echarts'
import $ from 'jquery'

export default {
  data () {
    return {
      loading: false,
      company: {},
      companycode: '',
      stype: '',
      legendCompany: [],
      showQrcode: false,  //分享二维码
      showsharedialog: false,  //分享弹窗
      DiyShareDesc: '',  //分享描述
      selectedTab: '',   //选中的tab
      dateDropmenu: false,
      selectedTab2: '',  //选中的二级tab
      tabList: {
        'baseinfo': '公司资料',
        'gudong': '股东',
        'finance': '财务分析',
        // 'companybigevent': '公司大事',
        // 'chart': '图谱',
        'mainbusiness': '主营业务',
        'customersandsuppliers': '客户与供应商', 
        'tradinginformation': '交易信息',
      },
      tabListH:{
        'baseinfo': '公司资料',
        'gudong': '股东',
        'finance': '财务分析',
      },
      queryParam: null,
    }
  },
  methods: {
    parseQuery: function() {
      let url = window.location.href;
    },
    scrollTop: function() {
      $('html,body').animate({scrollTop:0}, 'normal');
    },
    // 一级tab
    setSelectTab(typ) {
      this.selectedTab = typ;
      this.showDropdownMenu = false;
      this.setSelectTab2(1);
    },
    // 二级tab
    setSelectTab2(typ) {
      console.log('二级tab this.queryParam')
      console.log(this.selectedTab);
      this.selectedTab2 = typ;

      // 基本资料
      if (this.selectedTab === 'baseinfo') {
        if (typ == 1) {
          console.log("路由跳转到基本信息")
          this.$router.go({ path: '/company', query: this.queryParam });
        }
        if (typ === 2) {
          console.log('跳转到高管')
          this.$router.go({ path: '/company/gaoguan', query: this.queryParam });
        } 
      }

      // 股东
      if (this.selectedTab === 'gudong') {
        if(this.stype != 6){
          if (typ == 1) {
            this.$router.go({ path: '/company/invest', query: this.queryParam });
          } else if (typ === 2) {
            this.$router.go({ path: '/company/topten', query: this.queryParam });
          } else if (typ === 3) {
            this.$router.go({ path: '/company/sharechange', query: this.queryParam });
          }
        } else {
          this.$router.go({ path: '/company/topten', query: this.queryParam });
        }
      }

      // 财务分析
      if (this.selectedTab === 'finance') {
        if(this.stype == 6){
          if(typ == 1 || typ == 2){
            this.$router.go({ path: '/company/fzb', query: this.queryParam });
          } else if (typ === 3) {
            this.$router.go({ path: '/company/lrb', query: this.queryParam });
          } else if (typ === 4) {
            this.$router.go({ path: '/company/llb', query: this.queryParam });
          }
        }else {
          if (typ == 1) {
            this.$router.go({ path: '/company/finance', query: this.queryParam });
          } else if (typ === 2) {
            this.$router.go({ path: '/company/fzb', query: this.queryParam });
          } else if (typ === 3) {
            this.$router.go({ path: '/company/lrb', query: this.queryParam });
          } else if (typ === 4) {
            this.$router.go({ path: '/company/llb', query: this.queryParam });
          } else if (typ === 5) {
            this.$router.go({ path: '/company/performance', query: this.queryParam });
          } else if (typ === 6) {
            this.$router.go({ path: '/company/industryCompare', query: this.queryParam });
          }
        }
      }

      // 主营业务
      if (this.selectedTab === 'mainbusiness') {
        if (typ == 1) {
          this.$router.go({ path: '/company/mainproduct', query: this.queryParam });
        } else if (typ === 2) {
          this.$router.go({ path: '/company/mainindustry', query: this.queryParam });
        } else if (typ === 3) {
          this.$router.go({ path: '/company/mainlocation', query: this.queryParam });
        }
      }

      // 客户与供应商
      if (this.selectedTab === 'customersandsuppliers') {
        if (typ == 1) {
          this.$router.go({ path: '/company/customer', query: this.queryParam });
        } else if (typ === 2) {
          this.$router.go({ path: '/company/supplier', query: this.queryParam });
        } 
      }

      // 交易信息
      if (this.selectedTab === 'tradinginformation') {
        if (typ == 1) {
          this.$router.go({ path: '/company/tradeinfo', query: this.queryParam });
        } else if (typ === 2) {
          this.$router.go({ path: '/company/stocktops', query: this.queryParam });
        } else if (typ === 3) {
          this.$router.go({ path: '/company/largeexchange', query: this.queryParam });
        } 
      }
    },
    // 刷新页面  从新设置tab1  tab2
    setSelectedTab() {
      let url = window.location.href;
      console.log('---------------------------setSelectedTab companyMix.js组件');
      console.log(url)
      // console.log('setSelectTab')

      // 基本信息
      if (url.indexOf('/company?companycode') > 0 || url.indexOf('/company/?companycode')>0) {
        this.selectedTab = 'baseinfo';
        this.selectedTab2 = 1;
        this.setSelectTab2(1);
      }
      // 高管
      if (url.indexOf('gaoguan') > 0) {
        // console.log('gaogaun');
        this.selectedTab = 'baseinfo';
        this.selectedTab2 = 2;
        this.setSelectTab2(2);
      }

      // 机构持仓
      if (url.indexOf('invest') > 0) {
        this.selectedTab = 'gudong';
        this.selectedTab2 = 1;
        this.setSelectTab2(1);
      }
      // 十大股东
      if (url.indexOf('topten') > 0) {
        this.selectedTab = 'gudong';
        this.selectedTab2 = 2;
        this.setSelectTab2(2);
      }
      // 重要股东股权变动
      if (url.indexOf('sharechange') > 0) {
        this.selectedTab = 'gudong';
        this.selectedTab2 = 3;
        this.setSelectTab2(3);
      }

      // 公司综合能力分析
      if (url.indexOf('finance') > 0) {
        this.selectedTab = 'finance';
        this.selectedTab2 = 1;
        this.setSelectTab2(1);
      }
      // 负债表
      if (url.indexOf('/fzb') > 0) {
        this.selectedTab = 'finance';
        this.selectedTab2 = 2;
        this.setSelectTab2(2);
      }
      // 利润表
      if (url.indexOf('/lrb') > 0) {
        this.selectedTab = 'finance';
        this.selectedTab2 = 3;
        this.setSelectTab2(3);
      }
      // 流量表
      if (url.indexOf('/llb') > 0) {
        this.selectedTab = 'finance';
        this.selectedTab2 = 4;
        this.setSelectTab2(4);
      }
      // 业绩预告
      if (url.indexOf('/performance') > 0) {
        this.selectedTab = 'finance';
        this.selectedTab2 = 5;
        this.setSelectTab2(5);
      }
      // 行业对比
      if (url.indexOf('industryCompare') > 0) {
        this.selectedTab = 'finance';
        this.selectedTab2 = 6;
        this.setSelectTab2(6);
      }

      // 主营产品
      if (url.indexOf('mainproduct') > 0) {
        this.selectedTab = 'mainbusiness';
        this.selectedTab2 = 1;
        this.setSelectTab2(1);
      }
      // 主营行业
      if (url.indexOf('mainindustry') > 0) {
        this.selectedTab = 'mainbusiness';
        this.selectedTab2 = 2;
        this.setSelectTab2(2);
      }
      // 主营地域
      if (url.indexOf('mainlocation') > 0) {
        this.selectedTab = 'mainbusiness';
        this.selectedTab2 = 3;
        this.setSelectTab2(3);
      }

      // 客户信息
      if (url.indexOf('customer') > 0) {
        this.selectedTab = 'customersandsuppliers';
        this.selectedTab2 = 1;
        this.setSelectTab2(1);
      }
      // 供应商信息
      if (url.indexOf('supplier') > 0) {
        this.selectedTab = 'customersandsuppliers';
        this.selectedTab2 = 2;
        this.setSelectTab2(2);
      }


      // 交易信息
      if (url.indexOf('tradeinfo') > 0) {
        this.selectedTab = 'tradinginformation';
        this.selectedTab2 = 1;
        this.setSelectTab2(1);
      }
      // 龙虎榜
      if (url.indexOf('stocktops') > 0) {
        this.selectedTab = 'tradinginformation';
        this.selectedTab2 = 2;
        this.setSelectTab2(2);
      }
      // 大宗交易
      if (url.indexOf('largeexchange') > 0) {
        this.selectedTab = 'tradinginformation';
        this.selectedTab2 = 3;
        this.setSelectTab2(3);
      }
    },
    // 切换日期下拉框
    // showDateDropmemu: function(e) {
    //   var target = $(e.target);
    //   console.log('-----------');
    //   console.log(target);

    //   if (target.hasClass('dropdown-btn')) {

    //     if (target.next().css('display') == 'none') {
    //       target.next().css('display', 'block');
    //     } else if (target.next().css('display') == 'block') {
    //       target.next().css('display', 'none');
    //     }

    //   } else if (target.hasClass('dropdown-icon')) {

    //     if (target.parent('.dropdown-btn').next().css('display') == 'none') {
    //       target.parent('.dropdown-btn').next().css('display', 'block');
    //     } else if (target.parent('.dropdown-btn').next().css('display') == 'block') {
    //       target.parent('.dropdown-btn').next().css('display', 'none');
    //     }

    //   }
    // },
    // clickDropmenu: function() {
    //   $('.dropdown-menu').css('display', 'none');
    // },
    hideDropmenu: function(e) {
      let _con = $('.menu-lanmu');

      // 判断点击是否发生在空白区域
      if (!_con.is(e.target) && _con.has(e.target).length === 0) {
        this.dateDropmenu = false;
        // this.showDropdownMenu = false;
      }
    },
    // 公司对比
    companyCompare: function (x, n, u ,y) {
      console.log('use conpanyMix function company compare, this contain echarts');
      // console.log(x);
      // console.log(n);
      // console.log(u);
      // console.log(y);

      if (!y) {
        y = 5
      }
      var legend = x
      var xAxis = {}
      var extreme = []
      var years = []
      var yearMax = []
      var maxVal = null
      var minVal = null
      var unit = ''
      var yAxis = {
        'type': 'value',
        nameRotate: 0.1,
        axisLabel: {
          formatter: ''
        }
      }
      var series = []
      for (let k of n) {
        yAxis.name = k[0][1]
        k.shift()

        let arr = []
        for (let i of k) {
          arr.push(i[0])
        }
        years.push(arr)
      }

      for (let y of years) {
        if (y.length > 0) {
          yearMax.push(parseInt(y[y.length - 1].replace(/-/g, '')))
        }
      }
      let index = yearMax.indexOf(Math.max.apply(Math, yearMax))
      // console.log(years);
      // console.log(index);
      // console.log(years[index]);
      if (years[index]) {
        years[index].splice(0, years[index].length - y)
      }
      xAxis.data = years[index]
      // console.log(n)

      for (let i in n) {
        let x = {}
        x.name = legend[i]
        x.connectNulls = true
        x.type = this.chartType
        x.barMaxWidth = '20'
        if (years[index] && years[index].length > 0) {
          x.data = new Array(years[index].length)
          for (let item of n[i]) {
            for (let idx in years[index]) {
              if (years[index][idx] == item[0] && item[1] !== 0) {
                x.data[idx] = item[1]
              }
            }
          }
        } else {
          x.data = [];
        }
        series.push(x)
      }
      if (u[0] == '元') {
        for (let o of series) {
          for (let i of o.data) {
            if (i) {
              extreme.push(Math.abs(i))
            }
          }
        }
        function UnityUnits (x) {
          for (let item of series) {
            for (let i in item.data) {
              if (item.data[i]) {
                item.data[i] = (item.data[i] / x).toFixed(3)
              }
            }
          }
        }
        maxVal = Math.max.apply(Math, extreme)
        minVal = Math.min.apply(Math, extreme)
        if (maxVal > 100000000 && minVal > 100000000) {
          unit = '亿元'
          UnityUnits(100000000)
        } else if (maxVal > 100000000 && minVal > 10000) {
          unit = '万元'
          UnityUnits(10000)
        } else if (maxVal > 100000000 && minVal > 0) {
          unit = '万元'
          UnityUnits(10000)
        } else if (maxVal > 10000 && minVal > 10000) {
          unit = '万元'
          UnityUnits(10000)
        } else if (maxVal > 10000 && minVal > 0) {
          unit = '元'
          UnityUnits(1)
        } else if (maxVal > 0 && minVal > 0) {
          unit = '元'
          UnityUnits(1)
        }
        yAxis.axisLabel.formatter = '{value}' + unit
      } else {
        yAxis.axisLabel.formatter = '{value}' + u[0]
      }
      // console.log(series)
      // console.log(xAxis)
      // console.log(yAxis)
      // xAxis.push(datax)
      let that = this
      var show = setInterval(function () {
        if (document.querySelector('.industry-chard')) {
          let echart = document.querySelector('.industry-chard')
          var mychart = echarts.init(echart)
          var option = {
              tooltip : {
                trigger: 'axis',
                axisPointer : {            // 坐标轴指示器，坐标轴触发有效
                  type : 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
                }
              },
              toolbox: {
                show : true,
                feature : {
                  magicType : {
                    show: true,
                    type: ['line', 'bar'],
                    title: {line: '折线图', bar: '柱图'}
                  }
                }
              },
              legend: {
                data: legend,
                width:500,
              },
              grid: {
                left: '3%',
                right: '6%',
                bottom: '3%',
                top: '30%',
                containLabel: true
              },
              xAxis : xAxis,
              yAxis : [yAxis],
              graphic: [
                {
                  type: 'image',
                  left: 20,  // left right智能有一个生效
                  top: -10,
                  z: -10,
                  bounding: 'raw',
                  origin: [75, 75],
                  style: {
                      image: window.location.origin + '/static/images/analyze_shuiyin2.png',
                      width: 830,
                      height: 250,
                      opacity: 0.4
                  }
                }
              ],
              series : series
          };

          window.clearInterval(show)
          mychart.setOption(option, true)
          mychart.on('magictypechanged', function (params) {
            console.log(params)
            that.chartType = params.currentType
          })
        }
      },100)
    },
    showDateDropmemu: function() {
      this.dateDropmenu = this.dateDropmenu ? false : true;
    },
    clickDropmenu: function() {
      this.dateDropmenu = false;
    },
  },
  filters: {
    fomartTab(param) {
      for (let key in this.tabList) {
        if (this.selectedTab === key) {
          return this.tabList[key];
        }
      }
    },
    two: function (value) {
      if (value.toString().indexOf('.') >=0) {
        return value.toFixed(2)
      } else {
        return value
      }
    },
    formatMoney: function(num) {
      if (!num) {
        return num
      } else {
        num = parseFloat(num);
        return num.toLocaleString('en-US')
      }
    },
    formatStockTyp: function(param) {
      if (param == 'szse') {
        return '深交所';
      } else if (param == 'shse') {
        return '上交所';
      } else {
        return param;
      }
    },
    formatFloat: function(param) {
      if (!param) { return; }

      param = parseFloat(param);
      return param.toFixed(2);
    },
    nullValue: function(param) {
      if (!param || param == '') {
        return '-'
      } else {
        return param;
      }
    },
    toWan: function(param) {
      if (param) {
        param = parseFloat(param) / 10000;
        param = param.toFixed(2);
        return param.toLocaleString('en-US')
        // return param.toFixed(2);
      } else {
        return param;
      }
    },
    formatSnjlr: function(param) {
      if (!param || param == '') {
        return '-'
      }

      param = param.toString();
      let len = 0;
      if (param.indexOf('.') !== -1) {
        if (param.indexOf('-') !== -1) {
          len = param.split('.')[0].toString().length - 1;
        } else {
          len = param.split('.')[0].toString().length;
        }
      } else {
        if (param.indexOf('-') !== -1) {
          len = param.toString().length - 1;
        } else {
          len = param.toString().length;
        }
      }

      param = parseFloat(param);
      if (len>8) {
        param = param / 100000000;
        return param.toFixed(2).toLocaleString('en-US') + '亿';
      } else if (len>=5 && len <= 8) {
        param = param / 10000;
        return param.toFixed(2).toLocaleString('en-US') + '万元';
      } else {
        return param + '元';
      }
    },
    formatDate: function(param) {
      if (!param) return;

      param = param.toString();

      let year = param.substr(0, 4);
      let month = param.substr(4, 2);
      let day = param.substr(6);

      return year + '-' + month + '-' + day;
    },
    cheng100: function(param) {
      if (param === 0) {
        return param;
      }
      if (!param) {
        return;
      }
      param = parseFloat(param) * 100;
      return param.toFixed(2);
    },
    fundDate: function(param) {
      if (!param) return;

      param = param.toString();
      let year = param.substr(0, 4);
      let month = param.substr(4, 2);
      // let day = param.substr(6);
      if (parseInt(month) == 3) {
        return year + '年一季度';
      } else if (parseInt(month) == 6) {
        return year + '年半年度'
      } else if (parseInt(month) == 9) {
        return year + '年三季度'
      } else if (parseInt(month) == 12) {
        return year + '年年度'
      }
      // return year + '-' + month + '-' + day;
    },
    kong: function(k) {
      if (!k || k == 'null') {
        return '-';
      } else {
        return k;
      }
    },
  }
}


/** WEBPACK FOOTER **
 ** ./src/common/companyMix.js
 **/